import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const MODEL_GENERATION_BY_UUID_RESOURCE = "model-generation" as const;
export const MODEL_GENERATION_BY_UUID_API_PATH = `/v1/${MODEL_GENERATION_BY_UUID_RESOURCE}/{uuid}` as const;

export type ModelGenerationByUuidParameters =
  paths[typeof MODEL_GENERATION_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type ModelGenerationByUuidResponse =
  paths[typeof MODEL_GENERATION_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useModelGenerationByUuidQuery(uuid: string, options?: Options<ModelGenerationByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<ModelGenerationByUuidParameters, never>>(options);

  const requestParameters: ModelGenerationByUuidParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [MODEL_GENERATION_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<ModelGenerationByUuidResponse>(
        `/v1/${MODEL_GENERATION_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
